/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_Move_DownInputs */

const en_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Down 1 Line`)
};

const fr_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déplacer Vers le Bas de 1 Ligne`)
};

const de_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile nach unten gehen`)
};

const it_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostati di 1 riga verso il basso`)
};

const ru_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместитесь на одну строку вниз.`)
};

const es_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajar 1 línea`)
};

const zh_cn2_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下移动一行`)
};

const ja_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行下に移動`)
};

const hi_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक पंक्ति नीचे जाएं`)
};

const pt_pt2_input_position_y_move_down = /** @type {(inputs: Input_Position_Y_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desça uma linha`)
};

/**
* | output |
* | --- |
* | "Move Down 1 Line" |
*
* @param {Input_Position_Y_Move_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_move_down = /** @type {((inputs?: Input_Position_Y_Move_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Move_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_y_move_down(inputs)
	if (locale === "de") return de_input_position_y_move_down(inputs)
	if (locale === "it") return it_input_position_y_move_down(inputs)
	if (locale === "ru") return ru_input_position_y_move_down(inputs)
	if (locale === "es") return es_input_position_y_move_down(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_y_move_down(inputs)
	if (locale === "ja") return ja_input_position_y_move_down(inputs)
	if (locale === "hi") return hi_input_position_y_move_down(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_y_move_down(inputs)
	return en_input_position_y_move_down(inputs)
});